import { ApiError, apiRequest, authenticatedFetch } from './client'
import type { SilkAsset, SilkAssetKind, SilkAssetList } from './types'

/**
 * assetsApi - 用户资产上传 / 列表 / 删除
 *
 * upload 使用 fetch 直接发 multipart/form-data,因为 apiRequest 默认 JSON。
 */
export const assetsApi = {
  list: (params?: { kind?: SilkAssetKind; limit?: number; offset?: number }) =>
    apiRequest<SilkAssetList>('/api/v1/assets', { query: params }),

  delete: (id: number) =>
    apiRequest<{ ok: boolean }>(`/api/v1/assets/${id}`, { method: 'DELETE' }),

  upload: async (file: File, kind?: SilkAssetKind): Promise<SilkAsset> => {
    const form = new FormData()
    form.append('file', file)
    if (kind) form.append('kind', kind)

    const res = await authenticatedFetch('/api/v1/assets/upload', {
      method: 'POST',
      body: form,
    })
    const json = await res.json().catch(() => ({}))
    if (!res.ok || (json && json.code !== undefined && json.code !== 0)) {
      throw new ApiError({
        code: json?.code ?? 0,
        status: res.status,
        message: json?.message || `upload failed: ${res.status}`,
        payload: json,
      })
    }
    return json.data as SilkAsset
  },
}
